import { locale } from './const/locale';
export function getPlaceholder(picker, customizePlaceholder) {
  if (customizePlaceholder !== undefined) {
    return customizePlaceholder;
  }
  if (picker === 'year') {
    return locale.lang.yearPlaceholder;
  }
  if (picker === 'quarter') {
    return locale.lang.quarterPlaceholder;
  }
  if (picker === 'month') {
    return locale.lang.monthPlaceholder;
  }
  if (picker === 'week') {
    return locale.lang.weekPlaceholder;
  }
  if (picker === 'time') {
    return locale.timePickerLocale.placeholder;
  }
  return locale.lang.placeholder;
}
export function getRangePlaceholder(picker) {
  var placeholder = locale.lang.rangePlaceholder;
  switch (picker) {
    case 'year':
      {
        placeholder = locale.lang.rangeYearPlaceholder;
        break;
      }
    case 'month':
      {
        placeholder = locale.lang.rangeMonthPlaceholder;
        break;
      }
    case 'week':
      {
        placeholder = locale.lang.rangeWeekPlaceholder;
        break;
      }
  }
  return placeholder;
}